import {Injectable} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {DialogWidth} from '@q9elements/ui-kit/common';
import {FilterDescriptors} from '@q9elements/ui-kit/components';
import {filter, Observable} from 'rxjs';

import {DeleteViewDialogComponent} from '../components/delete-view-dialog/delete-view-dialog.component';
import {EditFiltersDialogComponent} from '../components/edit-filters-dialog/edit-filters-dialog.component';
import {EditViewDialogComponent} from '../components/edit-view-dialog/edit-view-dialog.component';
import {GridView} from '../models/interfaces';

@Injectable()
export class GridViewsDialogService {
  constructor(private dialog: MatDialog) {}

  create(view?: Partial<GridView>) {
    return this.dialog
      .open(EditViewDialogComponent, {
        width: DialogWidth.MD,
        data: view
      })
      .afterClosed()
      .pipe(filter(Boolean));
  }

  edit(view: GridView) {
    return this.dialog
      .open(EditViewDialogComponent, {
        width: DialogWidth.MD,
        data: view
      })
      .afterClosed()
      .pipe(filter(Boolean));
  }

  delete(view: GridView) {
    return this.dialog
      .open(DeleteViewDialogComponent, {
        width: DialogWidth.SM,
        data: view
      })
      .afterClosed()
      .pipe(filter(Boolean));
  }

  editFilters(view: GridView): Observable<{id: string; filters: FilterDescriptors}> {
    return this.dialog
      .open(EditFiltersDialogComponent, {
        data: view,
        width: DialogWidth.LG_XL
      })
      .afterClosed()
      .pipe(filter(Boolean));
  }
}
